import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function NavigationMenuRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const items = element.children ?? []

  const handleNavigate = (child: typeof items[number]) => {
    const route = child.variant ?? ""
    dispatchEvent(element.id, "navigate", { route })
  }

  return (
    <nav
      className={cn("flex items-center gap-1", element.className)}
      data-testid={`navigation-menu-${element.id}`}
    >
      {items.map((child) => {
        const label = child.text ? String(resolveSymbol(child.text) ?? "") : ""
        return (
          <button
            key={child.id}
            type="button"
            className="inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none"
            onClick={() => handleNavigate(child)}
          >
            {label}
          </button>
        )
      })}
    </nav>
  )
}
